import { SliderWidget } from '@tableau/widgets';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { MapStateToProps } from '~src/commonInfra/utils/ConnectUtils';
import { useUsage } from '~src/spacesPlatform/hooks/useUsage';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { CardResizerService } from '~src/spacesPlatform/services/CardResizerService';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';

// TODO: Update min and max values based on feedback after WAM.
const MIN_SLIDER_VALUE = CardResizerService.instance.CARD_RESIZE_SLIDER_MIN_VALUE * 100;
const MAX_SLIDER_VALUE = CardResizerService.instance.CARD_RESIZE_SLIDER_MAX_VALUE * 100;
const SLIDER_WIDTH = 100;
export const cardResizeSliderTestId = 'card-resizer';
export const cardResizerFeatureName = 'CardResizer';

const cardResizeSliderStyle: React.CSSProperties = {
    width: SLIDER_WIDTH,
};

interface CardResizeSliderOwnProps {

}

interface CardResizeSliderStateProps {
    readonly spaceInfo: SpaceInfo;
}

type CardResizeSliderProps = CardResizeSliderOwnProps & CardResizeSliderStateProps;

export function CardResizeSlider(props: CardResizeSliderProps): JSX.Element {

    const [sliderValue, setSliderValue] = React.useState<number>(CardResizerService.instance.getCardZoomPercentage() * 100);

    const spaceType = props.spaceInfo ? props.spaceInfo.spaceType : '';

    const sendClickThroughTelemetryEvent = useUsage(cardResizerFeatureName, { a: spaceType, c: CardResizerService.instance.getCardZoomPercentage() });

    const handleSliderChange = (value: number) => {
        setSliderValue(value);
        CardResizerService.instance.updateCardZoomPercentage(value / 100, true);
    };

    React.useEffect(() => {
        CardResizerService.instance.cardResizeSliderVisibilityChanged.trigger({ isCardSliderVisible: true });

        const cardZoomPercentage = CardResizerService.instance.getCardZoomPercentage() * 100;
        setSliderValue(cardZoomPercentage);

        return () => {
            CardResizerService.instance.cardResizeSliderVisibilityChanged.trigger({ isCardSliderVisible: false });
        };
    }, [spaceType]);

    return (
        <SliderWidget
            min={MIN_SLIDER_VALUE}
            max={MAX_SLIDER_VALUE}
            style={cardResizeSliderStyle}
            onChange={(value: number) => {
                handleSliderChange(value);
                sendClickThroughTelemetryEvent({ a: spaceType, c: value }, true);
            }}
            value={sliderValue}
            testId={cardResizeSliderTestId}
            ariaAttributes={{ 'aria-label': Messages.resizeCard() }}
        />
    );
}

const mapStateToProps: MapStateToProps<CardResizeSliderStateProps> = (state: AppState) => ({
    spaceInfo: selectSpaceInfo(state),
});

export const ConnectedCardResizeSlider: React.ComponentClass<CardResizeSliderOwnProps>
    = connect(mapStateToProps)(CardResizeSlider);